import axios from 'axios'
import store from '../store'
const baseUrls = store.state.baseUrls

const service = axios.create({
  baseURL: baseUrls + "/api/", // url = base url + request url
  timeout: 5000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    // if (sessionStorage.getItem('jwttoken')) {
    //   config.headers['Authorization'] = `Bearer ${sessionStorage.getItem('jwttoken')}`
    // }
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    return config
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (response.status == 200) {
      return Promise.resolve(res)
    } else {
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    return Promise.reject(error)
  }
)
export function request(url, option) {
  return new Promise((resolve, reject) => {
    let { methods, data, params, headers } = option
    service({
      url,
      method: methods || 'GET',
      data,
      params,
      headers
    })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}